import { render } from "./DashboardLeftCollaborators.vue?vue&type=template&id=edd0d42a&scoped=true"
import script from "./DashboardLeftCollaborators.vue?vue&type=script&lang=js"
export * from "./DashboardLeftCollaborators.vue?vue&type=script&lang=js"

import "./DashboardLeftCollaborators.vue?vue&type=style&index=0&id=edd0d42a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-edd0d42a"

export default script